
function addCatchupBundle(){
	if (document.title.indexOf('ourse') > 0 ){ //for all products with Course or course in name
      	console.log('Adding Catchup Bundle promotion');
      
      function submitAddToCartForm(){
     //   	$('#add-to-cart').on('click');
       //     $('#add-to-cart').click();
		}

		//$('#add-to-cart').attr('type','button');

        //$('#add-to-cart').off('click');
		$('#add-to-cart').on('click', 
			function(x){
				if ( confirm('Would you like to add 2 private catch-up lessons (worth £70), to be used by the end of the course, at the discounted price of £54?')){ 		  			         
                  	jQuery.post('/cart/add.js', {id:30174880583, quantity:1, success: submitAddToCartForm });     		  					  			
                } 				
			}
		);
    }else{
    	console.log('NOT Adding Catchup Bundle promotion');
    }
}

$(addCatchupBundle)